import { getOrderConfigOptions } from 'utils/getOrderConfigOptions'

export function optionIsInOrderConfig(option, orderConfig) {
  return getOrderConfigOptions(orderConfig).filter((c) => String(c) === String(option.id)).length > 0
}
